import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useContext, useEffect, useState } from "react";
import { pdficon, download_pdf_icon } from "../Assets/index";
import { AppContext, mainAPikey } from "../ContextApi";
import { useForm } from "react-hook-form";
import { ADD_EMPLOYEE_API, EDIT_EMPLOYEE_API } from "../Constants";
import { toast } from "react-toastify";

const convertDateFormat = (dobString) => {
  if (!dobString) return "";

  try {
    // Remove any extra spaces or commas
    dobString = dobString.replace(",", "").trim();

    // Convert to a Date object
    const dateParts = dobString.split(" ");
    const day = parseInt(dateParts[0], 10);
    const month = new Date(Date.parse(dateParts[1] + " 1")).getMonth(); // Get 0-based index
    const year = parseInt(dateParts[2], 10);

    // Create Date object
    const date = new Date(year, month, day);

    // Format as "YYYY-MM-DD" (required by <input type="date">)
    return date.toISOString().split("T")[0];
  } catch (error) {
    console.error("Error parsing date:", error);
    return "";
  }
};

// Example Usage
function CashlessEditModal(props) {
  const { data, type, relationData } = props;
  const { constantsApiData } = useContext(AppContext);
  const [isLoading, setLoading] = useState(false);
  const [relations, setRelations] = useState([]);

  const handleDownload = (url) => {
    const EcardsUrl = constantsApiData.path.E_CARDS_DATA_PATH;
    window.open(
      url.startsWith("https://") ? url : `${EcardsUrl}${url}`,
      "_blank"
    );
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: data?.member_name || "",
      DOB: data?.member_dob ? convertDateFormat(data?.member_dob) : "",
      age: data?.member_age || "",
      relationship_master_id: data?.relationship_master_id || "",
    },
  });


  const EmpoloyeeName = relationData?.find(
    (id) => id?.id === data?.relationship_master_id
  );

  useEffect(() => {
    reset({
      name: data?.member_name || "",
      DOB: data?.member_dob ? convertDateFormat(data?.member_dob) : "",
      age: data?.age || "",
      relationship_master_id: data?.relationship_master_id || "",
    });
  }, [data, reset]); // Ensure it runs when `data` changes

  useEffect(() => {
    if (data?.member_dob) {
      setValue("DOB", convertDateFormat(data?.member_dob)); // Manually set DOB
    }
  }, [data?.member_dob, setValue]);

  const authorizationToken = sessionStorage.getItem("authorizationToken");
  const today = new Date().toISOString().split("T")[0];

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  useEffect(() => {
    const DOB = watch("DOB");
    if (DOB) {
      setValue("age", calculateAge(DOB));
    }
  }, [watch("DOB"), setValue]);

  const onSubmit = async (dataRepo) => {
    setLoading(true);
    const formData = new FormData();
    Object.keys(dataRepo).forEach((key) => {
      formData.append(key, dataRepo[key]);
    });

    formData.append("member_covered_id", data?.member_covered_id);

    const apiUrl = `${process.env.REACT_APP_API_URL}/${mainAPikey}${EDIT_EMPLOYEE_API}`;

    const requestOptionsNew = {
      method: "POST",
      headers: {
        Authorization: authorizationToken,
      },
      body: formData,
    };

    try {
      const response = await fetch(apiUrl, requestOptionsNew);

      const result = await response.json();

      if (result?.success) {
        toast.success(result.message || "Form submitted successfully!");
        props.apiCall();
        props.handleClose();
        reset();
      } else {
        toast.error(result.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Edit Member</Modal.Title>
        <Button onClick={props.handleClose}>x</Button>
      </Modal.Header>
      <Modal.Body>
        <div className="pdf-download-cover-wrapper">
          {type === "cashless" ? (
            <div className="row">
              {data?.map((elem) => (
                <div className="col-lg-4" key={elem.file_name}>
                  <div className="download-pdf-box">
                    <div className="pdf-img-box">
                      <img src={pdficon} alt="PDF" />
                    </div>
                    <div className="pdf-name-box">
                      <h5>{elem.original_file_name}</h5>
                    </div>
                    <div
                      className="pdf-download-icon-box"
                      onClick={() => handleDownload(elem.file_name)}
                    >
                      <img src={download_pdf_icon} alt="Download" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="add-form-members-main-cover-wrapper">
              <form
                id="form-step-1"
                className="form-step active"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row claim-intimate-forms-cover d-flex">
                  {[
                    {
                      label: "Name",
                      name: "name",
                      type: "text",
                      required: "Name is required",
                    },
                    {
                      label: "Date of Birth",
                      name: "DOB",
                      type: "date",
                      required: "DOB is required",
                      max: today,
                    },
                    {
                      label: "Age",
                      name: "age",
                      type: "text",
                      required: "Age is required",
                      readOnly: true,
                    },
                    {
                      label: "Select Relation",
                      name: "relationship_master_id",
                      type: "select",
                      required: "Relation is required",
                    },
                  ].map((field) => (
                    <div className="col-lg-6 mb-3" key={field.name}>
                      <div className="form-group">
                        <label>
                          {field.label} <span className="error"> * </span>
                        </label>
                        {field.type === "select" ? (
                          <select
                            className="form-control"
                            {...register(field.name, {
                              required: field.required,
                            })}
                            value={EmpoloyeeName?.id || ""}
                          >
                            <option value="" disabled>
                              Select a Relation
                            </option>
                            {relationData?.map((relation) => (
                              <option key={relation.id} value={relation.id}>
                                {relation.relationship}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type={field.type}
                            className="form-control"
                            {...register(field.name, {
                              required: field.required,
                              ...(field.pattern
                                ? {
                                    pattern: {
                                      value: field.pattern,
                                      message: "Invalid format",
                                    },
                                  }
                                : {}),
                            })}
                            value={watch(field.name) || ""}
                            onChange={(e) =>
                              setValue(field.name, e.target.value)
                            }
                            max={field.max || ""}
                            readOnly={field.readOnly || false}
                          />
                        )}
                        {errors[field.name] && (
                          <small className="text-danger">
                            {errors[field.name].message}
                          </small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="submit-btn-box">
                  <input
                    type="submit"
                    className="register-form-btn mt-4 mb-3"
                    value={isLoading ? "Please wait..." : "Submit"}
                    disabled={isLoading}
                  />
                </div>
              </form>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CashlessEditModal;
